module.exports = __webpack_public_path__ + "media/icons/widget-icon-2@3x-f83489bb.svg";